$(document).ready(function () {
  // if ($(window).width() < 740) {
  //     $(".addslide").addClass('slide');
  //     $(".section-ideas").addClass('fp-noscroll');
  //     $(".idea-title-row").remove();
  //     $('.idea-content').unwrap();
  //     $(".more-ideas-btn").remove();
  // }
});

$(window).on("load", function () {
  function createFullpage() {
    var myFullpage = new fullpage("#splitscreen", {
      anchors: [
        "firstPage",
        "sectionHow",
        "secondPage",
        "sectionTeam",
        "sectionClients",
        "sectionIdeas",
        "sectionSmart",
        "sectionHire",
        "sectionMap",
      ],
      menu: "#myMenu",
      css3: true,
      slidesNavigation: true,
      resetSlidersKey:
        "aGFyd29vZGxldml0dC5jb21fWU0wY21WelpYUlRiR2xrWlhKekE5dA==",
      licenseKey: "D0F8BE04-34EB42E8-9D2A8479-C9C5AA5F",
      loopBottom: false,
      loopTop: false,
      scrollOverflow: true,
      loopHorizontal: true,
      fitToSection: true,
      autoScrolling: true,
      resetSliders: true,
      // scrollingSpeed: 1000,
      verticalCentered: false,
      normalScrollElements: "#job2, .idea",
      afterRender: function () {},

      onLeave: function (origin, destination, direction) {
        var leavingSection = $(this);

        clearInterval(slideInterval);
        var anchorsBis = [
          "firstPage",
          "sectionHow",
          "secondPage",
          "sectionTeam",
          "sectionClients",
          "sectionIdeas",
          "sectionSmart",
          "sectionHire",
          "sectionMap",
        ];

        anchorsBis.forEach((element) => {
          if (destination.anchor == element) {
            slideSwitch(...slidesData[element]);
          }
        });

        if (destination.anchor == "secondPage") {
          $(".square_who").css("opacity", "1");
          
        }

        if (destination.anchor != "secondPage") {
          $(".square_who").css("opacity", "0");
        } else {
          $(".square_who").css("opacity", "1");
        }

        if (destination.anchor == "sectionWhat") {
          $(".square_what").css("opacity", "1");
        } else {
          $(".square_what").css("opacity", "0");
        }

        if (destination.anchor == "sectionHow") {
          $(".square_home").css("left", "100%");
        } else {
          $(".square_home").css("left", "0");
        }

        if (destination.anchor == "sectionTeam") {
          $(".mosaics.team").css("display", "flex");
        } else {
          $(".mosaics.team").css("display", "none");
        }
        if (
          destination.anchor == "sectionClients" ||
          destination.anchor == "sectionIdeas"
        ) {
          $(".square_content").css("width", "100vw");
          $(".square_content").css("margin-left", "0vw");
          // fullpage_api.moveTo('sectionClients', 0);
        } else {
          $(".square_content").css("width", "50vw");
          $(".square_content").css("margin-left", "50vw");
        }

        if (destination.anchor == "sectionHire") {
          $(".mosaics.alumni").css("display", "flex");
        }
        //  else {
        //     $('.mosaics.alumni').css('display', 'none');
        // }

        if (destination.anchor == "sectionIdeas") {
          $(".categories-button").css("opacity", "1");
          $(".square_content").css("z-index", "0");
          $(".ideas").css("opacity", "1");
        } else {
          $(".categories-button").css("opacity", "0");
          $(".square_content").css("z-index", "initial");
          $(".ideas").css("opacity", "0");
        }

        if (destination.index == 0) {
          $(".square_who").css("opacity", "0");
          document.getElementById("go-top").style.display = "none";
        } else {
          $(".square_what").css("display", "flex");
          $(".square_who").css("display", "flex");
          document.getElementById("go-top").style.display = "block";
        }

        // if (destination.anchor == 'sectionSmart') {
        //     $('.session_list').addClass('slide_session_list');
        // } else {
        //     $('.session_list').removeClass('slide_session_list');
        // }

        if (origin.anchor == "sectionIdeas") {
          $(".categories-menu").slideUp("fast");
        }

        if (origin.anchor == 0) {
          $(".square_content").css("z-index", "initial");
        }

        if (destination.anchor == "sectionIdeas") {
          setTimeout(fullpage_api.reBuild(), 1200);
        }
        // if (section.anchor == 'sectionHire' && destination.index != 0) {
        //     $('.square_home').css('opacity', '0');
        // } else {
        //     $('.square_home').css('opacity', '.8');

        // }
      },

      onSlideLeave: function (section, origin, destination, direction) {
        var leavingSlide = this;

        if (section.index == 0 && destination.index != 0) {
          $(".square_home").css("border-width", "1vw");
        } else {
          $(".square_home").css("border-width", "8.25vw");
        }
        if (destination.index != 0) {
          $(".square_home").removeClass("square_home_hv");
        }
        if (section.anchor == "sectionTeam" && destination.index == 1) {
          slideSwitch(...slidesData["sectionTeam"]);
        }
        if (section.anchor == "sectionTeam" && destination.index == 0) {
          slideSwitch(...slidesData["sectionTeam"]);
        }

        if (section.anchor == "sectionHire" && destination.index != 0) {
          $(".square_home").css("opacity", "0");
        } else {
          $(".square_home").css("opacity", ".8");
        }
      },

      afterLoad: function (origin, destination, direction) {
        var loadedSection = this;

        if (destination.index == 0) {
          $(".square_home").hover(
            function () {
              $(".square_home").addClass("square_home_hv");
              $(".square_news > .btn").css("opacity", ".5");
            },
            function () {
              $(".square_home").removeClass("square_home_hv");
              $(".square_news > .btn").css("opacity", "1");
            }
          );
        }
      },

      afterSlideLoad: function (section, origin, destination, direction) {
        var loadedSlide = this;
        console.log(loadedSlide);
        if (section.anchor == "sectionHire" && destination.index == 1) {
        }
      },

      afterRender: function () {},
    });

    $("#what").hover(
      function () {
        $(".blue_what").css("width", "0px");
        $(".blue_what").css("height", "0px");
        $(".square_home").css("width", "16.66vw");
        $(".square_home").css("height", "16.66vw");
      },
      function () {
        $(".blue_what").css("width", "16.66vw");
        $(".blue_what").css("height", "16.66vw");
        $(".square_home").css("width", "33.33vw");
        $(".square_home").css("height", "33.33vw");
      }
    );

    $("#who").hover(
      function () {
        $(".square_who").css("opacity", "1");
        $(".square_who, .square_home").css("height", "34.5vw");
        $(".square_who, .square_home").css("width", "34.5vw");
        $(".white_who").css("height", "17.5vw");
        $(".white_who").css("width", "17.5vw");
        $(".white_who").css("opacity", "0");
      },
      function () {
        $(".white_who").css("opacity", "1");
        $(".square_who, .square_home").css("height", "33.33vw");
        $(".square_who, .square_home").css("width", "33.33vw");
        $(".white_who").css("height", "16.8vw");
        $(".white_who").css("width", "16.8vw");
      }
    );

    $(document).on("click", ".more-ideas-btn", function () {
      fullpage_api.reBuild();
    });

    $(document).on("click", ".alumni-link", function () {
      fullpage_api.moveSlideRight();
    });

    $(document).on("click", ".brand", function () {
      fullpage_api.moveTo(1);
    });
  }

  // $('#destroy').click(function () {
  //     fullpage_api.destroy('all');
  // });

  // $('#create').click(function () {
  //     createFullpage();
  // });
  $(".close-idea").click(function () {
    $(".idea").removeClass("active");

    // if ($(window).width() < 740) {
    //     $(".addslide").addClass('slide');
    //     $(".section-ideas").addClass('fp-noscroll');
    //     $(".idea-title-row").remove();
    //     $('.idea-content').unwrap();
    //     $(".more-ideas-btn").remove();
    //     $("#app").click();
    // }
    fullpage_api.silentMoveTo("sectionIdeas");
  });

  $(".close-job").click(function () {
    $(".job").removeClass("active");
    $("#app").click();
    fullpage_api.silentMoveTo("sectionHire");
  });

  $(window).resize(function () {
    windowWidth = $(this).width();
    fullpage_api.reBuild();
  });
  createFullpage();
});
